module.exports = __webpack_public_path__ + "img/img_blank_collection@2x.d26e0420.png";